export default __webpack_public_path__ + "static/media/G_D_btn__Ordini.28e8d997.svg";